import IconButton from '@mui/material/IconButton';
import { ReactComponent as EditICon } from '../assets/icons/main/create-icon.svg';
import { useTheme } from '@emotion/react';

interface EditButtonPropTypes {
  onClick: () => void;
  disabled?: boolean;
}

const Styles = {
  icon: {
    cursor: 'pointer',
    height: '24px',
    width: '24px',
  },
};

const EditButton = ({ onClick, disabled }: EditButtonPropTypes) => {
  const theme:any = useTheme();
  return (
    <IconButton onClick={onClick} disabled={disabled}>
      <EditICon style={{ ...Styles.icon, opacity: disabled ? 0.5 : 1, color : theme.palette.custom.light  }} />
    </IconButton>
  );
};

export default EditButton;
